import {AuthStateType} from "../../models"
import {RootState} from "../../../../models"

/**
 * @param state
 */
export const getAuthStateSlice = (state: RootState): AuthStateType => state.auth;

/**
 * @param state
 */
export const selectSigningIn = (state: RootState) => getAuthStateSlice(state).signingIn;

/**
 * @param state
 */
export const selectUser = (state: RootState) => getAuthStateSlice(state).user;

/**
 * @param state
 */
export const selectSignInErrorMessage = (state: RootState) => getAuthStateSlice(state).signInError;

/**
 * @param state
 */
export const selectAuthorizing = (state: RootState) => getAuthStateSlice(state).authorizing;
